import type { ReactElement } from 'react';
import type { RequestCounts, StatusFilter, UserRole } from '../../domain/types';
import { isProcurementStaffRole } from '../../domain/formatters';

interface SummaryTilesProps {
  role: UserRole;
  counts: RequestCounts;
  statusFilter: StatusFilter;
  onStatusFilter: (filter: StatusFilter) => void;
}

export function SummaryTiles({ role, counts, statusFilter, onStatusFilter }: SummaryTilesProps): ReactElement | null {
  if (role === 'Requestor') {
    return (
      <section className="tiles-grid">
        <article className={`tile ${statusFilter === 'draft' ? 'tile-active' : ''}`} onClick={() => onStatusFilter('draft')}>
          <h3>Draft</h3>
          <p>{counts.draft}</p>
        </article>
        <article
          className={`tile ${statusFilter === 'pendingApproval' ? 'tile-active' : ''}`}
          onClick={() => onStatusFilter('pendingApproval')}
        >
          <h3>Pending Approval</h3>
          <p>{counts.pendingApproval}</p>
        </article>
        <article
          className={`tile ${statusFilter === 'sourcing' ? 'tile-active' : ''}`}
          onClick={() => onStatusFilter('sourcing')}
        >
          <h3>Sourced</h3>
          <p>{counts.sourcing}</p>
        </article>
        <article
          className={`tile ${statusFilter === 'rejected' ? 'tile-active' : ''}`}
          onClick={() => onStatusFilter('rejected')}
        >
          <h3>Rejected</h3>
          <p>{counts.rejected}</p>
        </article>
      </section>
    );
  }

  if (role === 'RegionalManager') {
    return (
      <section className="tiles-grid">
        <article
          className={`tile ${statusFilter === 'pendingApproval' ? 'tile-active' : ''}`}
          onClick={() => onStatusFilter('pendingApproval')}
        >
          <h3>Pending Approval</h3>
          <p>{counts.pendingApproval}</p>
        </article>
        <article
          className={`tile ${statusFilter === 'procurementReview' ? 'tile-active' : ''}`}
          onClick={() => onStatusFilter('procurementReview')}
        >
          <h3>Procurement Review</h3>
          <p>{counts.procurementReview}</p>
        </article>
        <article
          className={`tile ${statusFilter === 'sourcing' ? 'tile-active' : ''}`}
          onClick={() => onStatusFilter('sourcing')}
        >
          <h3>Sourced</h3>
          <p>{counts.sourcing}</p>
        </article>
        <article
          className={`tile ${statusFilter === 'complete' ? 'tile-active' : ''}`}
          onClick={() => onStatusFilter('complete')}
        >
          <h3>Completed</h3>
          <p>{counts.complete}</p>
        </article>
      </section>
    );
  }

  if (isProcurementStaffRole(role) || role === 'Administrator' || role === 'ITSupport') {
    return (
      <section className="tiles-grid">
        <article
          className={`tile ${statusFilter === 'procurementReview' ? 'tile-active' : ''}`}
          onClick={() => onStatusFilter('procurementReview')}
        >
          <h3>Procurement Review</h3>
          <p>{counts.procurementReview}</p>
        </article>
        <article
          className={`tile ${statusFilter === 'sourcing' ? 'tile-active' : ''}`}
          onClick={() => onStatusFilter('sourcing')}
        >
          <h3>Sourcing</h3>
          <p>{counts.sourcing}</p>
        </article>
        <article
          className={`tile ${statusFilter === 'orderPlaced' ? 'tile-active' : ''}`}
          onClick={() => onStatusFilter('orderPlaced')}
        >
          <h3>Order Placed</h3>
          <p>{counts.orderPlaced}</p>
        </article>
        <article
          className={`tile ${statusFilter === 'procured' ? 'tile-active' : ''}`}
          onClick={() => onStatusFilter('procured')}
        >
          <h3>Procured</h3>
          <p>{counts.procured}</p>
        </article>
      </section>
    );
  }

  return null;
}
